import React, { useEffect, useState } from 'react';

export default function Logo({ businessName, salePointName, className = 'nav-logo', alt = 'Logo' }) {
    const [logoUrl, setLogoUrl] = useState('/assets/SalePoint1631330663733.jpg');

    useEffect(() => {
        if (!businessName || !salePointName) return;

        let isMounted = true;

        fetch(`/api/salePointConfig/${businessName}/${salePointName}`)
            .then((res) => {
                if (!res.ok) throw new Error(`API error: ${res.status}`);
                return res.json();
            })
            .then((config) => {
                if (isMounted && config.salePointLogoUrl) {
                    setLogoUrl(config.salePointLogoUrl);
                }
            })
            .catch((error) => {
                console.error('Error fetching logo config:', error);
                if (isMounted) {
                    setLogoUrl('/assets/default-logo.jpg');
                }
            });

        return () => {
            isMounted = false;
        };
    }, [businessName, salePointName]);

    return <img src={logoUrl} alt={alt} className={className} />;
}
